<script setup lang="ts">
const store = useSongStore();

</script>

<template>
  <SheetMusic
    label="Lead"
    :no-auth-reason="store.data?.products.lead.noAuthReason ?? null"
    :allow-preview="
      (store.song?.products.lead.authorized &&
        store.song?.products.lead.exists) ??
      false
    "
    :exceeded-max-unique-song-count="
      store.song?.products.lead.exceededMaxUniqueSongCount || false
    "
    placeholder-img="https://cdn.ccli.com/songselect/vue/placeholder-lead.svg"
    get-song-pdf-endpoint="/GetSongLeadPdf"
    get-song-preview-endpoint="/GetSongLeadPreview"
    :translated-title="$t('SV.LIT_LeadSheet')"
  />
</template>

<style scoped lang="postcss"></style>
